// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DebugController from "./debug_controller"
application.register("debug", DebugController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import PhotosController from "./photos_controller"
application.register("photos", PhotosController)

import PullToRefreshController from "./pull_to_refresh_controller"
application.register("pull-to-refresh", PullToRefreshController)

import QrController from "./qr_controller"
application.register("qr", QrController)

import ReactionsController from "./reactions_controller"
application.register("reactions", ReactionsController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)
